@if (allowZeroStars || overallStars) {
  @for (star of stars; track star; let i = $index) {
    <rma-icon [inline]="true" glyph="star" [fill]="starType(i, overallStars ?? 0)" />
  }
}
